export const saToast = ({ message = "", title = "Attenzione", type = "danger", duration = 5000 } = {}) => {
	// 1. Cerca o crea il contenitore nel body
	let container = document.querySelector(".sa-toast-container");
	if (!container) {
		container = document.createElement("div");
		container.className = "sa-toast-container";
		document.body.appendChild(container);
	}

	// 2. Crea il toast
	const toast = document.createElement("div");
	toast.className = `sa-toast ${type}`;
	toast.innerHTML = `
        <strong class="sa-toast-title">${title}</strong>
        <div class="sa-toast-body">${message}</div>
    `;

	// 3. Aggiungi al contenitore
	container.appendChild(toast);

	// 4. Autodistruzione dopo 5 secondi
	setTimeout(() => {
		toast.style.opacity = "0";
		toast.style.transition = "opacity 0.5s ease";
		setTimeout(() => toast.remove(), 500);
	}, duration);
};
